import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_HEADERS, ENDPOINTS } from "../../constants/api";
import { baseQueryWithAuthCheck } from "./helper";
import {
  TitleSkillSuggestionRes,
} from "../../types/api-response";
import { callFromMiddleware } from "../../utils";
import { TitleSkillSuggestionPayload } from "../../types/api-payload";

const baseQuery = fetchBaseQuery({
  baseUrl: window.location.origin,
  headers: API_HEADERS,
  credentials: "include",
});

export const jobposting = createApi({
  reducerPath: "jobposting",
  baseQuery: baseQueryWithAuthCheck(baseQuery),
  endpoints: (builder) => ({
    jobPostForm: builder.query<TitleSkillSuggestionRes[], TitleSkillSuggestionPayload>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.jobPost)}`,
        method: "POST",
        headers: API_HEADERS,
        body:body
      }),
    }),
    getJobPostCopy: builder.query<any, any>({
        query: (args) => ({
          url: `${callFromMiddleware(ENDPOINTS.getJobPostCopy)}/${args}`,
          method: "GET",
          headers: API_HEADERS,
        }),
    }),
    getJobPostEdit: builder.query<any, any>({
        query: (args) => ({
          url: `${callFromMiddleware(ENDPOINTS.getJobPostCopy)}/${args}`,
          method: "GET",
          headers: API_HEADERS,
        }),
    }),
     getJobPref: builder.query<any, any>({
        query: (params) => ({
          url: callFromMiddleware(ENDPOINTS.jobPreferences),
          method: "GET",
          headers: API_HEADERS,
          params,
        }),
    }),
  }),
  
});

export const {
 useLazyJobPostFormQuery,
 useLazyGetJobPostCopyQuery,
 useGetJobPostCopyQuery,
 useGetJobPostEditQuery,
 useLazyGetJobPrefQuery,
} = jobposting;

export default jobposting;